<button
  type="button"
  class="column-settings-trigger"
  [class.active]="open"
  (click)="toggle($event)"
  [attr.aria-expanded]="open"
  [attr.aria-label]="'table_columns.customize_table' | translate"
  [matTooltip]="'table_columns.customize_table' | translate"
  matTooltipPosition="below"
>
  <ui-svg-icon [svgIcon]="triggerIcon" size="small"></ui-svg-icon>
</button>

<div class="column-settings-backdrop" *ngIf="open" (click)="close()"></div>

<div class="column-settings-panel" *ngIf="open" [style.top]="panelTop" [style.right]="panelRight" (click)="$event.stopPropagation()">
  <div class="column-settings-section">
    <span class="column-settings-heading">{{ 'table_columns.drag_to_reorder' | translate }}</span>
    <!-- Only rendered when a host opts into a cap, so tables are unchanged. -->
    <span class="column-settings-hint" *ngIf="maxVisible !== null">
      {{ 'table_columns.max_visible' | translate: { max: maxVisible } }} · {{ visibleCount }}/{{ maxVisible }}
    </span>

    <!-- Pinned columns: anchored to the front, never reorderable. -->
    <div class="column-settings-list" *ngIf="pinnedColumns.length">
      <div class="column-settings-row column-settings-row--pinned" *ngFor="let column of pinnedColumns">
        <span class="column-settings-handle column-settings-handle--locked"></span>
        <span class="column-settings-label">{{ column.label | translate }}</span>

        <button
          type="button"
          class="column-settings-toggle"
          *ngIf="isHideable(column)"
          (click)="hide(column)"
          [attr.aria-label]="'table_columns.hide' | translate"
        >
          <ui-svg-icon svgIcon="eye-close" size="small"></ui-svg-icon>
        </button>
        <span
          class="column-settings-pin"
          *ngIf="!isHideable(column)"
          [attr.aria-label]="'table_columns.pinned' | translate"
        >
          <ui-svg-icon svgIcon="pin" size="small"></ui-svg-icon>
        </span>
      </div>
    </div>

    <!-- Reorderable columns. Some may be non-hideable (no eye), but still draggable. -->
    <div
      cdkDropList
      class="column-settings-list"
      (cdkDropListDropped)="onDrop($event)"
    >
      <div class="column-settings-row" *ngFor="let column of reorderColumns" cdkDrag>
        <span class="column-settings-handle" cdkDragHandle>
          <ui-svg-icon svgIcon="grip-vertical" size="small"></ui-svg-icon>
        </span>

        <span class="column-settings-label">{{ column.label | translate }}</span>

        <button
          type="button"
          class="column-settings-toggle"
          *ngIf="isHideable(column)"
          (click)="hide(column)"
          [attr.aria-label]="'table_columns.hide' | translate"
        >
          <ui-svg-icon svgIcon="eye-close" size="small"></ui-svg-icon>
        </button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="hiddenColumns.length">
    <div class="column-settings-divider"></div>

    <div class="column-settings-section">
      <span class="column-settings-heading">{{ 'table_columns.hidden' | translate }}</span>

      <div class="column-settings-list">
        <div class="column-settings-row column-settings-row--hidden" *ngFor="let column of hiddenColumns">
          <span class="column-settings-label">{{ column.label | translate }}</span>

          <button
            type="button"
            class="column-settings-toggle"
            [disabled]="atCapacity"
            [attr.title]="atCapacity ? ('table_columns.max_visible' | translate: { max: maxVisible }) : null"
            (click)="show(column)"
            [attr.aria-label]="'table_columns.show' | translate"
          >
            <ui-svg-icon svgIcon="eye" size="small"></ui-svg-icon>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
